module.exports = __webpack_public_path__ + "img/3-1.5ef2c0f4.jpg";